import { defineStore } from "pinia";
import { ref } from "vue";
import useMyFetch from "@stores/useMyFetch";
import { captureEvent } from "@/lib/analytics";

export const usePptxImportStore = defineStore("pptxImport", () => {
  const themeToken = ref(null);
  const analyzing = ref(false);
  const analyzeError = ref(null);

  function setThemeToken(token) {
    themeToken.value = token;
  }

  async function analyze(uploadedFile) {
    analyzing.value = true;
    analyzeError.value = null;

    try {
      const formData = new FormData();
      formData.append("file", uploadedFile);

      const { response, data } = await useMyFetch(`/master_reports/${themeToken.value}/pptx_imports/analyze`)
        .post(formData)
        .json();

      if (!response.value?.ok) {
        analyzeError.value = data.value?.error || "Failed to import PPTX";
        return false;
      }

      captureEvent("pptx_imported", { master_report_token: themeToken.value });

      return true;
    } catch (e) {
      analyzeError.value = e.message || "Failed to import PPTX";
      return false;
    } finally {
      analyzing.value = false;
    }
  }

  return {
    themeToken,
    analyzing,
    analyzeError,
    analyze,
    setThemeToken,
  };
});
